var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHideLayout(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 21.802,
    viewBox: "0 0 168 21.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_BOOKLAND",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M158.957,3.632h-1.817v14.53h1.817c3.633,0,5.449-3.632,5.449-7.265s-1.816-7.265-5.449-7.265M151.692,0h7.265c5.449,0,10.9,3.632,10.9,10.9s-5.449,10.893-10.9,10.9l-7.265,0Z",
    transform: "translate(-1.854 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M141.422,0h5.449V21.794h-4.541L134.158,9.082V21.794h-5.45V0h4.541l8.173,12.706Z",
    transform: "translate(-1.573 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M117.53,12.714l-1.817-7.265L113.9,12.714ZM112.989,0h5.449L125.7,21.794h-5.449l-1.817-5.449h-5.449l-1.817,5.449h-5.449Z",
    transform: "translate(-1.292 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M90.1,0h5.449V18.171h7.265V21.8H90.1Z",
    transform: "translate(-1.101 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M77.18,10.9A10.787,10.787,0,0,0,86.262,0H84.445A9.153,9.153,0,0,1,77.18,9.081C80.812,7.265,82.629,4.541,82.629,0H79c0,3.632-1.817,8.173-5.449,9.081v3.633C77.18,13.621,79,18.162,79,21.794h7.265A10.787,10.787,0,0,0,77.18,10.9",
    transform: "translate(-0.899 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 5.449,
    height: 21.794,
    transform: "translate(66.292)",
    fill: "#00183f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M53.212,3.632c3.619,0,4.527,3.633,4.527,7.265s-.908,7.265-4.541,7.265S48.658,14.53,48.658,10.9s.909-7.265,4.555-7.265M53.222,0c6.334,0,9.966,3.632,9.966,10.9s-3.632,10.9-9.989,10.9S43.21,18.162,43.21,10.9,46.842,0,53.222,0",
    transform: "translate(-0.528 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M29.309,3.632c3.619,0,4.527,3.633,4.527,7.265s-.908,7.265-4.541,7.265-4.54-3.632-4.54-7.265.908-7.265,4.554-7.265M29.319,0c6.334,0,9.966,3.632,9.966,10.9s-3.632,10.9-9.989,10.9-9.989-3.632-9.989-10.9S22.939,0,29.319,0",
    transform: "translate(-0.236 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M5.449,9.081h.909c.908,0,3.632,0,3.632-2.723S7.265,3.632,6.357,3.632H5.449Zm0,9.082H7.265c.908,0,3.632,0,3.632-2.724s-2.724-2.724-3.632-2.724H5.449ZM0,0H9.081c3.633,0,6.357,1.817,6.357,5.449A4.237,4.237,0,0,1,10.9,9.989a5.234,5.234,0,0,1,5.449,5.449c0,4.541-3.228,6.356-7.265,6.356H0Z",
    transform: "translate(0 0)",
    fill: "#00183f",
    fillRule: "evenodd"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideLayout);
export default __webpack_public_path__ + "static/media/hide-layout.603028b1.svg";
export { ForwardRef as ReactComponent };